<template>
  <div style="width: 100%; height: 100%; overflow: hidden; min-width: 965px">
    <nav-bar></nav-bar>
    <zyyj-header></zyyj-header>
    <div class="main-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import NavigateBar from '@/components/common/NavBar'
import SecondNavBar from '@/components/common/SecondNavBar'
import Header from '@/components/common/Header'
export default {
  props: [],

  components: {
    'nav-bar': NavigateBar,
    'second-nav-bar': SecondNavBar,
    'zyyj-header': Header
  },

  data () {
    return {}
  },

  watch: {},

  computed: {},

  mounted () {},

  methods: {}
}
</script>

<style lang="scss" scoped>
.header {
  float: right;
  display: flex;
  align-items: center;
  height: 60px;
  width: calc(100% - 60px);
  background: #ffffff;
}
.header-title {
  height: 28px;
  margin-left: 25px;
  font-size: 20px;
  font-weight: 600;
  color: #444444;
  line-height: 28px;
}
.header-user {
  position: absolute;
  right: 20px;
}
/deep/ .el-dropdown {
  cursor: pointer;
}
.main-content {
  float: right;
  width: calc(100% - 60px);
  height: calc(100% - 60px);
}
</style>



// WEBPACK FOOTER //
// src/components/common/Container.vue